
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-time-buyers",
      function () {
        return require("private-next-pages/first-time-buyers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-time-buyers"])
      });
    }
  